import { render, staticRenderFns } from "./FileManagerList.vue?vue&type=template&id=445a6abf"
import script from "./FileManagerList.vue?vue&type=script&lang=js"
export * from "./FileManagerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports